import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { ChevronRight } from "@/assets/icons/icons";
import { FocusRing } from "@/components/Layout/BaseLayouts/Footer/FocusRing";
import { KEYBOARD_TAB_INDEX } from "@/utils/keyboardTabIndex";

/**
 * A standalone external link styled as an inverted NavItem (xl size) with a
 * chevron-right icon. Used in the footer top row alongside the collapsible menus.
 */
export const SupportLinkItem = () => {
  const { t } = useTranslation();

  return (
    <a
      className={clsx(
        "group relative inline-flex h-9 w-fit items-center gap-2 rounded-md p-1",
        "text-body-lg font-semibold text-foreground-primary-inverse",
        "hover:bg-surface-secondary-inverse active:bg-surface-secondary-inverse",
        "focus:outline-none",
      )}
      aria-label={t("Common.support")}
      href={t("Footer.support.url")}
      tabIndex={KEYBOARD_TAB_INDEX}
      target="_blank"
      rel="noreferrer"
    >
      <span className="whitespace-nowrap">{t("Common.support")}</span>
      <ChevronRight className="shrink-0" />
      <FocusRing inverted />
    </a>
  );
};
